export default () => {
    let parallaxs = document.querySelectorAll('.parallax-wrapper')

    parallaxs.forEach(p => {
        let image = p.querySelector('img'),
            image_src = image.src,            
            image_alt = image.alt

        image.parentNode.removeChild(image)

        let bg  = document.createElement('div'),
            img = document.createElement('img')
        bg.classList.add('bg')
        img.setAttribute('src', image_src)
        img.setAttribute('alt', image_alt)
        img.classList.add('bg__img')
        bg.appendChild(img)

        p.querySelector('.parallax-image').appendChild(bg)
        p.style.left = `${(window.innerWidth - document.querySelector('.exhibition').getBoundingClientRect().width)/-2}px`

        window.addEventListener('resize', () => {
            p.style.left = `${(window.innerWidth - document.querySelector('.exhibition').getBoundingClientRect().width)/-2}px`
            p.querySelector('.parallax-description').style.margin = `0 ${(window.innerWidth - document.querySelector('.exhibition').getBoundingClientRect().width)/2}px`
        })
    })
}


// WEBPACK FOOTER //
// ./scripts/modules/parallax.js